import { SummaryDetail } from '@/types/summary'
import { CourseId, Reason } from '@/types/user'
import { Calligraphy, Property, SubMenu } from '.'

interface Props {
  summary: SummaryDetail
  reason?: number
  courseId?: CourseId
  readThisMonth?: number
}
export const Info: React.FC<Props> = ({
  summary,
  reason = Reason.CAN_NOT_READABLE,
  courseId = CourseId.anonymous,
  readThisMonth = 0,
}) => {
  return (
    <div className="flex w-full pc">
      <div className="flex-1"></div>
      <div className="flex mb-[30px] w-[1024px]">
        <div className="flex mr-[30px] w-[716px]">
          <Calligraphy id={summary.id} title={summary.title} />
          <Property summary={summary} />
        </div>
        <SubMenu
          shops={summary.shops}
          summary={summary}
          reason={reason}
          courseId={courseId}
          readThisMonth={readThisMonth}
        />
      </div>
      <div className="flex-1"></div>
    </div>
  )
}
